import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=d7c6a3a0&"
import script from "./VerifyForm.vue?vue&type=script&lang=js&"
export * from "./VerifyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports